import React from "react";
import { useForm } from "react-hook-form";
import { useSignUpContext } from "../../../context/signup/signupcontext";

interface DemographicsProps {
  nextStep: () => void;
}

const Demographics: React.FC<DemographicsProps> = ({ nextStep }) => {
  const { setFormData, formData } = useSignUpContext();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: formData?.demographics?.firstName || "",
      lastName: formData?.demographics?.lastName || "",
      gender: formData?.demographics?.gender || "",
      phoneNumber: formData?.demographics?.phoneNumber || "",
      companyName: formData?.demographics?.companyName || "",
    },
  });

  React.useEffect(() => {
    reset(formData?.demographics);
  }, [reset, formData]);

  const onSubmit = (data: any) => {
    setFormData({ demographics: data });
    nextStep();
  };

  return (
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="title-container">
        <img
          height="40px"
          src="https://notifygridmedia.s3.us-east-2.amazonaws.com/black+R+transparent.png"
          alt="Roloniumlabs logo"
        />
        <h2 className="form-title">Create your Account</h2>
        <p>Rolonium Account is all you need to access all Rolonium Services.</p>
      </div>
      <div className="firstLastContainer">
        <input
          className="form-input"
          type="text"
          {...register("firstName", { required: "First Name is required" })}
          placeholder="First Name"
        />
        {errors.firstName && (
          <p className="error">{errors.firstName.message as string}</p>
        )}

        <input
          className="form-input"
          type="text"
          {...register("lastName", { required: "Last Name is required" })}
          placeholder="Last Name"
        />
        {errors.lastName && (
          <p className="error">{errors.lastName.message as string}</p>
        )}
      </div>

      <select
        className="form-input"
        {...register("gender", { required: "Gender is required" })}
      >
        <option value="" disabled hidden>
          Select your gender
        </option>
        <option value="male">Male</option>
        <option value="female">Female</option>
      </select>
      {errors.gender && (
        <p className="error">{errors.gender.message as string}</p>
      )}

      <input
        className="form-input"
        type="text"
        {...register("phoneNumber", { required: "Phone Number is required" })}
        placeholder="Mobile Phone Number"
      />
      {errors.phoneNumber && (
        <p className="error">{errors.phoneNumber.message as string}</p>
      )}

      <input
        className="form-input"
        type="text"
        {...register("companyName", { required: "Company Name is required" })}
        placeholder="Company Name"
      />
      {errors.companyName && (
        <p className="error">{errors.companyName.message as string}</p>
      )}

      <div className="form-actions">
        <button type="submit" className="btn primary-btn">
          Next
        </button>
      </div>
    </form>
  );
};

export default Demographics;
